import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import { makeT } from "@/lib/i18n";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [lang, setLang] = useState(() => localStorage.getItem("itoo_lang") || "en");
  const [theme, setTheme] = useState(() => localStorage.getItem("itoo_theme") || "dark");
  const dir = lang === "ar" ? "rtl" : "ltr";
  const t = makeT(lang);

  useEffect(() => {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("itoo_lang", lang);
  }, [lang, dir]);

  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    localStorage.setItem("itoo_theme", theme);
  }, [theme]);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };
  const toggleLang = () => setLang((l) => (l === "en" ? "ar" : "en"));
  const toggleTheme = () => setTheme((th) => (th === "dark" ? "light" : "dark"));

  const isAdmin = user && ["PLATFORM_ADMIN", "ENTERPRISE_ADMIN"].includes(user.role);

  return (
    <AppCtx.Provider value={{ user, setUser, lang, setLang, toggleLang, dir, t, theme, toggleTheme, login, logout, checkAuth, isAdmin, formatApiError }}>
      {children}
    </AppCtx.Provider>
  );
}
